import {createContext} from 'react';
import {ContextValue} from './types';

const CompanyContext = createContext<ContextValue>(null);

export default CompanyContext;
